var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2353 7.99317C17.0406 7.99885 16.8556 8.0801 16.7197 8.21973L10.25 14.6895L7.78027 12.2197C7.71116 12.1478 7.62838 12.0903 7.53679 12.0507C7.44519 12.0111 7.34662 11.9902 7.24684 11.9892C7.14706 11.9882 7.04808 12.0071 6.9557 12.0448C6.86331 12.0825 6.77939 12.1383 6.70883 12.2088C6.63827 12.2794 6.5825 12.3633 6.54478 12.4557C6.50706 12.5481 6.48816 12.6471 6.48917 12.7468C6.49019 12.8466 6.5111 12.9452 6.55069 13.0368C6.59028 13.1284 6.64774 13.2112 6.71972 13.2803L9.71972 16.2803C9.86038 16.4209 10.0511 16.4999 10.25 16.4999C10.4489 16.4999 10.6396 16.4209 10.7803 16.2803L17.7803 9.28028C17.8885 9.1749 17.9623 9.03931 17.9922 8.89126C18.0221 8.74321 18.0065 8.58959 17.9477 8.4505C17.8888 8.31142 17.7893 8.19335 17.6622 8.11175C17.5351 8.03015 17.3863 7.98882 17.2353 7.99317Z",
    fill: "#0A0A0A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIco);
export default __webpack_public_path__ + "static/media/check-ico.a6f2c8e2.svg";
export { ForwardRef as ReactComponent };